/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_NL = {
  "  Checked by (signature)": "  Gecontroleerd door (handtekening)",
  "! 3 of 4 types required:": "! 3 van de 4 types vereist:",
  "! Min. 14 characters": "! Min. 14 tekens",
  "! No name/username parts": "! Geen delen van naam/gebruikersnaam",
  "! No spaces": "! Geen spaties",
  "/ occasion": "/ gelegenheid",
  "A new password should be different than the current one": "Een nieuw wachtwoord moet anders zijn dan het huidige",
  "ACCEPTED": "AANVAARD",
  "Active flights": "Actieve vluchten",
  "Add deicing/anti-icing": "Voeg de-icing/anti-icing toe",
  "Add description": "Beschrijving toevoegen",
  "Add description if there is a irregularity!": "Voeg de beschrijving toe als er een onregelmatigheid is!",
  "Add line": "Regel toevoegen",
  "Add location where item was found": "Locatie toevoegen waar item is gevonden",
  "Add note": "Notitie toevoegen...",
  "add occasion": "gelegenheid toevoegen",
  "Add other location": "Andere locatie toevoegen",
  "Add row": "Rij toevoegen",
  "Add storage location": "Opslaglocatie toevoegen",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Voeg je herstelmail toe zodat we je een code kunnen sturen als je je wachtwoord vergeet.",
  "additional services": "Aanvullende diensten",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Na het klikken op 'BEVESTIGEN', wordt de correctie MVT verzonden. Het kan opnieuw worden verzonden als er een wijziging is in ALDT of/ en AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Na het klikken op 'BEVESTIGEN', wordt de MVT verzonden. Het kan opnieuw worden verzonden als er een wijziging is in ALDT of/ en AIBT.",
  "Agent's name:": "Naam van de employee: ",
  "Agent's signature:": "Handtekening van employee:",
  "Aircraft Damage": "Vliegtuig Schade",
  "Aircraft type": "Vliegtuigtype",
  "Airline": "Luchtvaartmaatschappij",
  "All": "Allemaal",
  "ALL": "ALLE",
  "All Airlines with Stocks": "Alle luchtvaartmaatschappijen met stocks",
  "An error occurred while trying to verify your email address.": "Er is een fout opgetreden bij het verifiëren van uw e-mailadres.",
  "and": " en ",
  "and/or": "en/of",
  "Anti-icing": "Anti-icing",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Elke e-mail met @aviapartner.aero of @aviavip.com wordt niet geaccepteerd!",
  "APPLY": "TOEPASSEN",
  "approved": "goedgekeurd",
  "Apr": "Apr",
  "Archived": "Gearchiveerd",
  "Are you sure you want to change your password?": "Weet u zeker dat u uw wachtwoord wilt wijzigen?",
  "Are you sure you want to exit the current process?": "Weet u zeker dat u het huidige proces wilt afsluiten?",
  "Are you sure you want to remove photo?": "Weet u zeker dat u de foto wilt verwijderen?",
  "Are you sure you want to sign out?": "Weet u zeker dat u zich wilt afmelden?",
  "area": "gebied",
  "Arrival MVT has been sent": "Arrival MVT is verzonden",
  "Arrival MVT not sent yet": "Arrival MVT nog niet verzonden",
  "Arrival MVT sending": "Verzenden van Arrival MVT",
  "Arrival MVT sent successfully": "Arrival MVT succesvol verzonden",
  "Attach photo": "Foto bijvoegen",
  "Attachment": "Bijlage",
  "Aug": "Aug",
  "Available": "Beschikbaar",
  "Belt": "Belt",
  "Body": "Lichaam",
  "Briefly describe where the item will be stored for picking up.": "Beschrijf kort waar het item wordt opgeslagen om te worden opgehaald.",
  "Call {{firstName}} {{lastName}}": "Bel {{firstName}} {{lastName}}",
  "Call sign": "Roepnaam",
  "Cancel": "Annuleren",
  "CANCEL": "ANNULEREN",
  "Cannot be after": "Kan niet na zijn ",
  "Cannot be before": "Kan niet eerder zijn ",
  "Cannot create MVT message: missing flight information": "Kan geen MVT-bericht maken: ontbrekende vluchtinformatie",
  "Cannot send Arrival MVT": "Kan Arrival MVT niet verzenden, Adressen (SITA en/of e-mail) voor deze vlucht zijn niet geconfigureerd in Sunrise",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Kan de Aankomst MVT niet verzenden. Adressen (SITA en/of e-mail) voor deze vlucht zijn niet geconfigureerd in Sunrise.",
  "Cannot send MVT ETD": "Kan MVT ETD niet verzenden, Adressen (SITA en/of e-mail) voor deze vlucht zijn niet geconfigureerd in Sunrise",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Kan de MVT ETD niet verzenden. Adressen (SITA en/of e-mail) voor deze vlucht zijn niet geconfigureerd in Sunrise.",
  "Cannot set a future time.": "Kan geen toekomstige tijd instellen.",
  "Change": "Verander",
  "Change password": "Wijzig wachtwoord",
  "Change password?": "Wachtwoord veranderen?",
  "Change your password:": "Wachtwoord wijzigen:",
  "Checked by (signature)": "Gecontroleerd door (handtekening)",
  "Checks on easily visible parts of the aircraft from the ground": "Controleer gemakkelijk zichtbare delen van het vliegtuig vanaf de grond:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Controles op gemakkelijk zichtbare delen van het vliegtuig vanaf de grond. Geen duidelijke schade of anomalieën aan:",
  "Chocks": "Smoorspoelen",
  "Chute": "Chute",
  "CLEAR": "Overzichtelijk",
  "Client's signature:": "Handtekening van de klant:",
  "Clocked Time": "Geregistreerde Tijd",
  "Close": "Sluiten",
  "CLOSE": "SLUITEN",
  "Close all my sessions on all devices": "Sluit al mijn sessies op alle apparaten",
  "Close registration": "Sluit de registratie",
  "CLOSE REGISTRATION": "REGISTRATIE SLUITEN",
  "close the flight": "sluit de vlucht",
  "Closed": "Closed",
  "Closing this window will discard all your recent changes.": "Als u dit venster sluit, gaan al uw recente wijzigingen verloren.",
  "Clouds": "Wolken",
  "Comment": "Commentaar",
  "Comment...": "Opmerking...",
  "Comments": "Commentaar",
  "Completed": "Voltooid",
  "Conditional services": "Voorwaardelijke diensten",
  "Cones": "Kegels",
  "CONFIRM": "BEVESTIGEN",
  "Confirm": "Bevestigen",
  "Confirm new password": "Nieuw wachtwoord bevestigen",
  "Confirm remove?": "Bevestig verwijderen?",
  "CONFIRMED": "BEVESTIGD",
  "Contact your administrator to request access": "Neem contact op met uw beheerder om toegang te vragen",
  "Could not save data, please try again later": "Kon geen gegevens opslaan, probeer het later nog eens",
  "Crew signature": "HANDTEKENING CREW",
  "Current password": "Huidig wachtwoord",
  "Damage": "Schade",
  "Date range": "Datumbereik",
  "Date should not be before start date": "De datum mag niet vóór de begindatum liggen",
  "Day": "Dag",
  "Dec": "Dec",
  "DECLINED": "VERWIJDERD",
  "Default station": "Standaard station",
  "Deicing": "Ontdooiing",
  "Deicing Service Registration": "Registratie van ontijzingsservice",
  "Delete Photo": "Foto verwijderen",
  "DENIED": "DENIED",
  "Describe location": "Beschrijf locatie",
  "Dest.": "Dest.",
  "Destination": "Bestemmings",
  "Did you forget something?": "Ben je iets vergeten?",
  "Don't use phone while driving!": "Gebruik geen telefoon tijdens het rijden!",
  "Dummy Type": "Dummy Type",
  "Edit Comment": "Reactie bewerken",
  "Emergency": "Noodgeval",
  "Emergency contacts are not set up": "Noodcontacten zijn niet ingesteld.",
  "employees": "medewerkers",
  "End": "Einde",
  "End of anti-icing": "Einde van de anti-ijsvorming",
  "End Time": "Eindtijd",
  "End time should not be before start time": "De eindtijd mag niet voor de begintijd liggen",
  "Entrance": "Ingang",
  "Error loading clocked times": "Fout bij het laden van geregistreerde tijden",
  "Error. The email doesn't meet standard formatting.": "Fout. De e-mail voldoet niet aan de standaardindeling.",
  "exceeds the allowed limit for this flight": " o verschrijdt de toegestane limiet voor deze vlucht.",
  "Executor's name:": "Naam van de executeur:",
  "Executor's signature:": "Handtekening van de executeur:",
  "extra service": "Extra service",
  "Extra services": "Extra diensten",
  "Extra shift request": "Extra ploegendienst verzoek",
  "Extra Shift Request": "Extra ploegendienst verzoek",
  "Extra shift request confirmed": "Extra dienst verzoek bevestigd",
  "failed": "mislukt",
  "Feb": "Feb",
  "Filter": "Filter",
  "Filter group": "Filter groep",
  "Filter group has not been updated": "Filtergroep is niet bijgewerkt",
  "filter group not found": "filtergroep niet gevonden",
  "finalization": "afronding",
  "Find the account recovery section and click \"Resend verification email\".": "Zoek de sectie accountherstel en klik op \"Verificatie-e-mail opnieuw verzenden\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: Een document kan niet worden geschreven omdat het de maximaal toegestane grootte overschrijdt",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Een document kan niet worden geschreven omdat het de maximaal toegestane grootte overschrijdt",
  "Flight": "Vlucht",
  "Flight details": "Vluchtgegevens",
  "Flight information registration": "Registratie van vluchtinformatie",
  "Flight not found": "Vlucht niet gevonden",
  "Flight number/registration": "Vluchtnummer/registratie",
  "Flight registration is closed": "De vluchtregistratie is gesloten.",
  "Flight reopened": "Vuelo reabierto",
  "Flight type": "Vluchttype",
  "Flights": "Vluchten",
  "Fluid name": "Vloeistofnaam",
  "Fluid name:": "Vloeistofnaam:",
  "Fluid type": "Vloeistoftype",
  "Forgot your password?": "Vergeten uw wachtwoord?",
  "Forms": "Formulieren",
  "from": "van",
  "From": "Van",
  "Full (Wings, stabilizer &, fuselage)": "Volledig (Vleugels, stabilisator & romp)",
  "Future time is not allowed": "Toekomstige tijd is niet toegestaan",
  "Gate": "Poort",
  "General info": "Algemene info",
  "Go to flights": "Ga naar vluchten",
  "Go to login": "Ga naar de inlogpagina",
  "Go to My Profile in your Sunrise account.": "Ga naar Mijn Profiel in uw Sunrise-account.",
  "Go to Unread R&S": "Ga naar Ongelezen R&S",
  "Helpdesk": "Helpdesk",
  "Hold Inspection on Arrival": "Hold inspectie aankomst",
  "Hold Inspection on Departure": "Hold inspectie vertrek",
  "hr": "uur",
  "Humidity": "Vochtigheid",
  "If damage is found, mark it on the sketch": "Als er schade wordt gevonden, markeer deze dan op de schets",
  "If the problem continues, go to My Profile to resend a new verification link.": "Als het probleem aanhoudt, gaat u naar Mijn Profiel om een nieuwe verificatielink opnieuw te verzenden.",
  "In order to close this flight you need to provide": "Om deze vlucht af te sluiten dient u verplichte gegevens in te vullen.",
  "In order to close this flight you need to provide mandatory details.": "Om deze vlucht af te sluiten, moet je verplichte details verstrekken.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Om 'Agenda' te openen, lees en verwerk recente Read & Sign-berichten",
  "In order to send Arrival MVT you need to provide mandatory details": "Om Arrival MVT te verzenden, moet je verplichte details verstrekken",
  "Include nearby area": "Omvat nabijgelegen gebied",
  "Included nearby area": "Inbegrepen nabijgelegen gebied",
  "Incorrect code": "Onjuiste code",
  "Input a brief description here": "Geef hier een korte beschrijving",
  "Inspected by": "Geïnspecteerd door",
  "Inspection agent's signature": "Handtekening van de inspectieagent",
  "Inspection agent's signature:": "Handtekening van de inspecteur:",
  "Inspections": "Inspecties",
  "Instructions": "Instructies",
  "Internal communication": "Interne communicatie",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Ongeldige ALDT/AIBT-waarde of Arrival MVT met dergelijke ALDT- en AIBT-waarden bestaat al",
  "is logged in": "is ingelogd",
  "Is Partial": "Is gedeeltelijk",
  "is signed in": "is getekend in",
  "It's safe and encrypted - only used for password resets.": "Het is veilig en versleuteld — alleen gebruikt om je wachtwoord te herstellen.",
  "Jan": "Jan",
  "Job vacancy": "Vacature",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "SLEUTELPERSONEN",
  "Language": "Taal",
  "Leave a comment about this timestamp and connected action.": "Laat een reactie achter over dit tijdstempel en de bijbehorende actie.",
  "Left Engine": "Linker motor",
  "Left Tail Wing": "Linker staartvleugel",
  "Left Wing": "Linkervleugel",
  "Load Verification Cross-Check Form": "Laadverificatie Cross-Check Formulier",
  "Local (Under Wing / Local area contamination)": "Lokaal (Onder de vleugel / Lokale vervuiling)",
  "Local Bags": "Lokale tassen",
  "Locked application": "Geblokkeerde applicatie",
  "Log in": "Lees en teken",
  "Log out": "Log uit.",
  "Lost item": "Verloren voorwerp",
  "lowercase": "kleine letters",
  "Mar": "Mar",
  "Mark location": "Plaats markeren",
  "May": "Mei",
  "Message archived": "Bericht gearchiveerd",
  "Message state": "Berichtstatus",
  "Message type": "BERICHTINGSTYPE",
  "Message unarchived": "Bericht niet gearchiveerd",
  "Messages": "Berichten",
  "messages yet": "berichten nog",
  "min": "min",
  "Mix": "Mix",
  "Month": "Maand",
  "MVT History": "MVT Geschiedenis",
  "My profile": "Mijn profiel",
  "Name Surname": "Naam Achternaam",
  "Neck": "Hals",
  "New password": "Nieuw wachtwoord",
  "New password cannot be equal to current": "Het nieuwe wachtwoord mag niet gelijk zijn aan het huidige.",
  "New password does not meet security requirements": "Le nouveau mot de passe ne répond pas aux exigences de sécurité",
  "next": "volgende",
  "Next 5 days": "Volgende 5 dagen",
  "No": "Nee",
  "No active flights yet": "Nog geen actieve vluchten",
  "No clocked times available": "Geen geregistreerde tijden beschikbaar",
  "No content yet...": "Nog geen inhoud...",
  "No flight details information": "Geen informatie over de vlucht",
  "No instructions found": "Geen instructies gevonden",
  "No internet connection": "Nessuna connessione a Internet",
  "No key people assigned.": "Geen sleutelpersonen toegewezen.",
  "No messages yet": "Nog geen berichten",
  "No photo available": "Geen foto beschikbaar",
  "No photos here yet": "Nog geen foto's hier",
  "No registration": "Geen registratie",
  "No services available": "Geen diensten beschikbaar",
  "No time logging found": "Geen tijdregistratie gevonden",
  "No timestamps configured for this flight type": "Geen tijdstempels geconfigureerd voor dit vluchttypes",
  "No types here yet": "Nog geen types hier",
  "no user data": "geen gebruikersgegevens",
  "None": "Geen",
  "Nose": "Neus",
  "Not completed": "Niet voltooid",
  "Note": "Opmerking:",
  "Nov": "Nov",
  "NOW": "NU",
  "Number of unread R&S:": "Aantal ongelezen R&S:",
  "numbers": "cijfers",
  "occasion": "gelegenheid",
  "Occasion": "gelegenheid",
  "Oct": "Oct",
  "Oops! It looks like your verification email didn't go through.": "Oeps! Het lijkt erop dat uw verificatie-e-mail niet is doorgekomen.",
  "Open": "Open",
  "Open a flight to add it to your active flights list.": "Open een vlucht om deze toe te voegen aan uw lijst met actieve vluchten.",
  "Open file": "Open bijlage",
  "Open flight {{name}}": "Open vlucht {{name}}",
  "Operation flight number": "Vluchtnummer",
  "Operator's name": "Naam van de operator",
  "Operator's name:": "Naam van de operator:",
  "Operator's signature": "Handtekening van de operator",
  "Operator's signature:": "Handtekening van de operator:",
  "Optional": "Optioneel",
  "or": "of",
  "Origin": "Oorsprong",
  "Other flights": "Andere vluchten",
  "Outside Air Temperature": "Buitenluchttemperatuur (C°)",
  "Outside Air Temperature (C°)": "Buitentemperatuur (C°)",
  "Page not found": "Pagina niet gevonden",
  "Parking": "Parkeren",
  "Partially (Wings & stabilizer only)": "Deels (Alleen vleugels & stabilisator)",
  "Password": "Wachtwoord",
  "Password must be at least 8 characters": "Het wachtwoord moet ten minste 8 tekens lang zijn en ten minste 1 hoofdletter en 1 kleine letter, 1 symbool, 1 cijfer en geen spaties bevatten.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Wachtwoord is niet uniek. Uw nieuwe wachtwoord mag niet een van uw laatste 5 gebruikte wachtwoorden zijn.",
  "Passwords do not match": "Wachtwoorden komen niet overeen",
  "per occasion": "per gelegenheid",
  "Per pax": "Per pax",
  "per start": "per start",
  "percent": "procent",
  "Photo registration": "Foto registratie",
  "Photo types required": "Foto's zijn vereist",
  "Photo types required:": "Vereiste fototypen:",
  "Photos": "Foto's",
  "Pick if its a damaged part or lost item": "Kies of het een beschadigd onderdeel of verloren voorwerp is.",
  "Pin on schema": "Speld op schema",
  "Please briefly describe where you found the item": "Beschrijf kort waar u het voorwerp heeft gevonden. Specificeer kamer of lijn en rij indien beschikbaar",
  "Please click here to proceed to flights list": "Klik hier om door te gaan naar de vluchtenlijst",
  "Please make sure you attached photos of irregularities": "Zorg ervoor dat u foto's van onregelmatigheden bijvoegt",
  "Please pick on scheme": "Kies alsjeblieft een schema",
  "Please reach out to your administrator for assistance": "Neem contact op met uw beheerder voor hulp.",
  "Please try sending it again later.": "Probeer het later opnieuw te verzenden.",
  "Please try the link again.": "Probeer de link opnieuw.",
  "Please, sign below": "Ondertekenen a.u.b",
  "Post-deicing/anti-icing check completed": "Controle na het ontdooien/anti-ijsvorming voltooid",
  "Precipitation": "Neerslag",
  "Pressure": "Druk",
  "Proceed to login": "Ga verder met inloggen",
  "Product name": "Productnaam",
  "Product type": "Producttype",
  "Profile": "Profiel",
  "Profile data wasn't updated!": "Profielgegevens werden niet geüpdatet!",
  "Psychosocial aid": "Psychosociale hulp",
  "Quantity (liter)": "Hoeveelheid (liter)",
  "Read": "Lezen",
  "Read & Sign": "Lees en teken",
  "Read & Sign to do:": "Lees & Onderteken om te doen:",
  "Read&Sign": "Lees & teken",
  "Receive Extra shift requests": "Ontvang extra dienstverzoeken",
  "Receive job vacancies": "Vacatures ontvangen",
  recovery: {
    "error1": "<1>Oeps!</1> Het lijkt erop dat uw verificatie-e-mail niet is verzonden.",
    "error2": "<1>Probeer het later opnieuw te verzenden.</1>",
    "error3": "Onze excuses voor het ongemak.",
    "inUse": "Dit herstel-e-mailadres is al <1>in gebruik!</1>",
    "success": "De <1>verificatie-e-mail</1> is succesvol verzonden!",
    validation: {
      "blockedDomainNote": "een e-mailadres met <1>@aviapartner.aero</1> of <3>@aviavip.com</3> wordt niet geaccepteerd!",
      "invalidFormat": "Fout. Het e-mailadres voldoet niet aan het standaardformaat."
    },
    "verified": "Uw herstel-e-mail is al <1>geverifieerd!</1>"
  },
  "Recovery email": "Herstel-e-mail",
  "Recovery email already verified!": "Herstel-e-mail al geverifieerd!",
  "Recovery email verified!": "Herstel-e-mail geverifieerd!",
  "Reg.": "Reg.",
  "Registration": "Registratie",
  "Registration Closed": "Inschrijving gesloten",
  "REGISTRATION CLOSED": "REGISTRATIE GESLOTEN",
  "registration complete": "registratie compleet",
  "Remark": "Remark",
  "Remove": "Verwijder",
  "Remove {{name}} from active flights": "Verwijder {{name}} uit actieve vluchten",
  "Reopen": "Heropenen",
  "reopen flight": "vlucht heropenen",
  "Report any irregularities found upon arrival": "Meld eventuele onregelmatigheden die bij aankomst zijn geconstateerd",
  "Report any other irregularities": "Meld eventuele andere onregelmatigheden",
  "Required": "Vereist",
  "required to close the flight": "vereist om de vlucht te sluiten",
  "Requirements of the password are not met.": "Aan de wachtwoordvereisten is niet voldaan.",
  "Resend verification email": "Verificatie-e-mail opnieuw verzenden",
  "Right Engine": "Juiste motor",
  "Right Tail Wing": "Rechter staartvleugel",
  "Right Wing": "Rechts",
  "Runway": "Startbaan",
  "Safety Ramp Checklist": "Veiligheidsrampchecklist",
  "Safety Ramp Inspection": "Inspectie van de veiligheidsrampe",
  "SAVE": "Save",
  "save": "save",
  "Save service registrations problem": "Probleem met dienstregistraties opslaan",
  "Screening": "Screening",
  "Search": "Zoeken op",
  "Seat": "Seat",
  "Seats": "Zitplaatsen",
  "Select type": "Kies type",
  "SEND ARRIVAL MVT": "VERZEND ARRIVAL MVT",
  "SEND CORRECTION ARRIVAL MVT": "VERZEND CORRECTIE ARRIVAL MVT",
  "Send the Arrival MVT message to recipients:": "Verzend het Arrival MVT-bericht naar de ontvangers:",
  "SENT": "SENT",
  "Sep": "Sep",
  "Service info saved": "Service info opgeslagen",
  "Service registration": "Serviceregistratie",
  "Service registration is closed": "Registratie voor de dienst is gesloten.",
  "Service Type": "Servicetype",
  "Set": "Set",
  "Set date": "Datum instellen",
  "Set time": "Stel tijd in",
  "Set time: End of anti-icing": "Stel tijd in: Einde van de anti-ijsvorming",
  "Set to now": "Ingesteld op nu",
  "Short remark": "Korte opmerking",
  "Show": "Toon",
  "Show Photo": "Toon Foto",
  "Sign for understanding": "Teken voor begrip",
  "Sign form below to complete it": "Onderteken hieronder om het formulier in te vullen:",
  "Sign in": "Meld je aan.",
  "Sign out": "Log uit",
  "Signed": "Ondertekend",
  "SKIP": "OVERSLAAN",
  "Skip this step": "Sla deze stap over",
  "Something went wrong": "Er is iets misgegaan.",
  "Something went wrong. Please try again later.": "Er is iets misgegaan. Probeer het later opnieuw.",
  "Something wrong": "Er klopt iets niet.",
  "Sort.": "Sort.",
  "Specify where did you found the item": "Geef aan waar u het voorwerp hebt gevonden",
  "Start": "Start",
  "Start anti-icing": "Start anti-icing",
  "Start Time": "Begintijd",
  "Station": "Station",
  "Stations": "Stations",
  "Stop anti-icing": "Stop anti-icing",
  "success": "succes",
  "Sunrise": "Zonsopgang",
  "Sunset": "Zonsondergang",
  "Switch flight": "Vlucht wisselen",
  "symbols": "symbolen",
  "SYSTEM SETTINGS": "SYSTEEMINSTELLINGEN",
  "Tail": "Staart",
  "Take a photo": "Neem een foto",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Maak een foto van een voltooide actie, waaraan dit tijdstempel is gewijd.",
  "Tap on area where damaged part is located": "Tik op de plaats waar het beschadigde onderdeel zich bevindt",
  "Task": "Taak",
  "Tasks & Flights": "Taken & Vluchten",
  "Telex messages": "Telex berichten",
  "Temperature (C°)": "Temperatuur (C°)",
  "The app has been updated": "De app is bijgewerkt",
  "The APPI code is required when resetting your Aviapartner": "De APPI code is nodig bij het resetten van uw Aviapartner account wachtwoord in Sunrise of via de Aviapartner helpdesk. U kunt uw APPI code altijd terugvinden in uw profiel in Sunrise.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "De APPI-code is vereist bij het resetten van uw Aviapartner-accountwachtwoord in Sunrise of via de Aviapartner-helpdesk. U kunt uw APPI-code altijd in uw profiel in Sunrise vinden.",
  "the correction MVT will be sent": "Na het klikken op 'BEVESTIGEN' wordt de correctie MVT verzonden. Het kan opnieuw worden verzonden als er een wijziging is in ALDT en/of AIBT",
  "The current password you entered is incorrect.": "Het ingevoerde huidige wachtwoord is onjuist.",
  "The current password you've entered is incorrect": "Het huidige wachtwoord dat u heeft ingevoerd is onjuist. Controleer het nogmaals en probeer het opnieuw.",
  "The elapsed time between": "De verstreken tijd tussen ",
  "The end time must be later than the start time.": "De eindtijd moet later zijn dan de begintijd.",
  "the MVT will be sent": "Na het klikken op 'BEVESTIGEN' wordt de MVT verzonden. Het kan opnieuw worden verzonden als er een wijziging is in ALDT en/of AIBT",
  "The planning shown below might not be up-to-date": "Het kan zijn dat onderstaande planning niet actueel is.",
  "The shift is already confirmed to": "De dienst is al bevestigd aan",
  "The username or password you've entered is incorrect": "De gebruikersnaam of het wachtwoord dat u hebt ingevoerd is onjuist. Controleer het nogmaals en probeer het opnieuw. ",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "De gebruikersnaam of het wachtwoord dat u hebt ingevoerd is onjuist. Controleer het nogmaals en probeer het opnieuw.",
  "The verification email has been sent successfully!": "De verificatie-e-mail is succesvol verzonden!",
  "This action is mandatory.": "Deze actie is verplicht.",
  "This field is mandatory": "Dit veld is verplicht",
  "This form is signed": "Dit formulier is ondertekend",
  "This message is marked as urgent": "Dit bericht is gemarkeerd als dringend",
  "This recovery email is already in use!": "Deze herstel-e-mail is al in gebruik!",
  "This request is not valid anymore": "Dit verzoek is niet meer geldig",
  "This section is used to deal with visible damage to the airplane": "Deze sectie wordt gebruikt voor het behandelen van zichtbare schade aan het vliegtuig. Documenteer elk zichtbaar probleem voordat u onderhoud uitvoert.",
  "This service has been registered for this flight over 80% of the time.": "Deze service is in meer dan 80% van de gevallen geregistreerd voor deze vlucht.",
  "time": " tijd.",
  "Time registration": "Tijdregistratie",
  "Timeline": "Tijdlijn",
  "Timestamp information": "Tijdstempelinformatie",
  "Timestamps type": "Type tijdstempels",
  "to": "naar",
  "To get a new one, simply follow these steps:": "Om een nieuwe te krijgen, volgt u eenvoudig deze stappen:",
  "Today": "Vandaag",
  "TODAY": "VANDAAG",
  "Tomorrow": "Morgen",
  "Transfer Bags": "Transferbags",
  "Truck Driver": "Vrachtwagenchauffeur",
  "Truck driver's signature": "Handtekening van de vrachtwagenchauffeur",
  "Truck driver's signature:": "Handtekening vrachtwagenchauffeur:",
  "Truck Number": "Vrachtwagennummer",
  "type": "type",
  "Type": "Type",
  "Unavailable": "Niet beschikbaar",
  "Unread": "Ongelezen",
  "Until": "Tot",
  "Unverified email": "Niet-geverifieerde e-mail!",
  "uppercase": "hoofdletters",
  "Username": "Gebruikersnaam",
  "Username or email": "Gebruikersnaam of e-mail",
  "validating": "valideren van",
  "validation": "validatie",
  "Verification Error": "Verificatiefout",
  "Verification Link Expired": "Verificatie-link is verlopen",
  "Verified email": "Geverifieerde e-mail",
  verify: {
    "alreadyVerifiedTitle": "Herstel-e-mail al geverifieerd!",
    "error1": "Er is een fout opgetreden bij het verifiëren van je e-mailadres.",
    "error2": "Probeer de link opnieuw.",
    "error3": "Als het probleem aanhoudt, ga naar <1>Mijn profiel</1> om een nieuwe verificatielink te verzenden.",
    "errorTitle": "Verificatiefout",
    "expiredStep1": "Ga naar <1>Mijn profiel</1> in je Sunrise-account.",
    "expiredStep2": "Zoek het gedeelte voor accountherstel en klik op \"Verificatie-e-mail opnieuw verzenden\".",
    "expiredStepsIntro": "Volg gewoon deze stappen om een nieuwe te krijgen:",
    "expiredTitle": "Verificatielink verlopen",
    "successDescription": "Je kunt deze nu gebruiken om weer toegang te krijgen tot je account als je je wachtwoord vergeet.",
    "successTitle": "Herstel-e-mail geverifieerd!",
    "verifying": "Verifiëren..."
  },
  "Verifying...": "Verifiëren...",
  "View key people": "Bekijk sleutelfiguren",
  "Visibility": "Zicht",
  "Visual checks must be performed AFTER GSE removal": "Visuele controles moeten worden uitgevoerd NA verwijdering van materiaal",
  "Visual checks must be performed BEFORE GSE positioning": "Visuele controles moeten worden uitgevoerd VOORDAT materiaal wordt geplaatst",
  "Walkaround Arrival Checklist": "Aankomst walkaround checklist",
  "Walkaround Pre-Departure Checklist": "Pré-vertrek walkaround checklist",
  "We apologize for the inconvenience.": "Onze excuses voor het ongemak.",
  "We strongly recommend saving it in your smartphone phonebook": "Wij raden u ten zeerste aan de code op te slaan in uw telefoonboek van uw smartphone, zodat u de APPI-code altijd bij de hand hebt. Om de code op te slaan, ga je naar je Sunrise profiel en scan je de QR code met je smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "We raden u ten zeerste aan de code op te slaan in uw telefoonboek van uw smartphone, zodat u de APPI-code altijd bij de hand hebt. Om de code op te slaan, ga je naar je Sunrise profiel en scan je de QR code met je smartphone.",
  "Weather": "Weer",
  "Wind": "Wind",
  "Would you like to add it to your current registration?": "Wil je het toevoegen aan je huidige registratie?",
  "Write comment": "Schrijf commentaar",
  "write new comment": "nieuwe opmerking schrijven",
  "Write your comment here, then press the green check mark": "Schrijf hier uw commentaar, druk dan op het groene vinkje",
  "Year": "Jaar",
  "Yes": "Ja",
  "Yesterday": "Gisteren",
  "You are offline": "Je bent offline.",
  "You can check your APPI code on Sunrise portal.": "Je kunt je APPI code controleren op Sunrise portal.",
  "You can now use it to regain access to your account if you forget your password.": "U kunt het nu gebruiken om weer toegang te krijgen tot uw account als u uw wachtwoord bent vergeten.",
  "You can't remove this temporal item": "Je kunt dit tijdelijke item niet verwijderen",
  "You don't have permission to view clocked times": "U heeft geen toestemming om geregistreerde tijden te bekijken",
  "You don't have permissions to take a photo": "Je hebt geen toestemming om een foto te nemen",
  "You were signed out automatically": "U werd automatisch afgemeld. Token is verlopen. U kunt zich weer aanmelden met uw inloggegevens",
  "Your password and confirmation password do not match": "Uw wachtwoord en bevestigingswachtwoord komen niet overeen.",
  "Your password has been changed successfully!": "La tua password è stata cambiata con successo!",
  "Your password has expired. Please compose a new password and log in again.": "Uw wachtwoord is verlopen. Gelieve een nieuw paswoord samen te stellen en opnieuw in te loggen.",
  "Your password must contain at least eight characters": "La tua password deve contenere almeno otto caratteri, almeno un numero e lettere sia minuscole che maiuscole.",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Uw wachtwoord moet uit minimaal acht tekens bestaan, minstens één cijfer bevatten en zowel kleine als hoofdletters bevatten.",
  "Your recovery email is already verified!": "Uw herstel-e-mail is al geverifieerd!",
  "Your session has expired. Please sign in again.": "Uw sessie is verlopen. Gelieve opnieuw in te loggen."
};
